$(function() {
    //「②考える」アコーディオン開閉
    $( '.accordion-btn' ).click(function() {
        // テキスト開閉
        $( this ).next( '.accordion-text' ).slideToggle( 200 );
        // 矢印回転
        $( this ).toggleClass( 'open', 200 );
    });
});

//input 日付
$(function () {
    flatpickr(".js-datePicker", {
        locale: "ja",
        dateFormat: "Y/m/d",
        disableMobile: true,
    });
});
